module.exports = __webpack_public_path__ + "img/logo-econet.62c70203.svg";